/**
 * 对axios稍作封装
 * 1. 设置请求超时时间
 * 2. 添加请求拦截器，在每个请求的头部添加token
 * 3. 添加响应拦截器，根据服务器返回状态进行相应的结果返回
 */

import axiosObj, { AxiosRequestConfig, AxiosResponse } from "axios";
import store from "../store";
import router from "../router";
import { pendingRequest } from "@/type/ComponentDataType";
import redirectHelper from "@/utils/redirectHelper";

const defaultConfig = {
    // baseURL在此处省略配置,考虑到项目可能由多人协作完成开发，域名也各不相同，此处通过对api的抽离，域名单独配置在base.js中

    // 请求超时时间
    timeout: 5 * 60 * 1000,
    // 跨域请求时是否需要凭证
    // withCredentials: true, // Check cross-site Access-Control
    headers: {
        // 设置默认请求头，当需要特殊请求头时，将其作为参数传入，即可覆盖此处的默认参数(第三个参数即config)
        // 例如：
        // services.post(`${base.lkBaseURL}/uploads/singleFileUpload`, file, {
        // headers: { "Content-Type": "multipart/form-data" }
        // });
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
    },
    // 在向服务器发送请求前，对数据进行处理，axios默认会序列化数据
    // transformRequest:[function(data){
    //
    // }],
    // 在传递给 then/catch 前，修改响应数据
    // transformResponse:[function(data){
    //
    // }]
};

// 是否正在刷新的标记
const isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
const requests: pendingRequest[] = [];

// 创建实例
const _axios = axiosObj.create(defaultConfig);
// 请求拦截器
_axios.interceptors.request.use(
    function (config: AxiosRequestConfig) {
        // 从vuex里获取token
        const token = store.state.token;
        // 如果token存在就在请求头里添加
        token && (config.headers.Authorization = token);

        return config;
    },
    function (error) {
        // Do something with request error
        error.data = {};
        error.data.msg = "服务器异常";
        return Promise.reject(error);
    }
);
// 响应拦截器
_axios.interceptors.response.use(
    function (response: AxiosResponse) {
        if (response.status === 401) {
            redirectHelper.saveCurrentUrl();

            //直接转到登录页
            store.commit("logoutUserInfo");

            if (response.config.url?.includes("rpamobile")) {
                router.push({ name: "mobile-single-login" });
            } else {
                router.push({ name: "single-login" });
            }
        }
        if (response.status === 200) {
            // 处理接口中的data
            if (response.data) {
                if (typeof response.data === "string") {
                    try {
                        const dataObj = JSON.parse(response.data);
                        if (typeof dataObj == "object" && dataObj) {
                            // 为json字符串将其转为json对象
                            response.data = dataObj;
                        }
                    } catch (e) {
                        // 不是json字符串就不处理
                        return response;
                    }
                }
            }
            return response;
        }
        response.data.code = -1;
        response.data.msg = "服务器错误";
        return response;
    },
    function (error) {
        redirectHelper.saveCurrentUrl();

        if (error) {
            if (error.response.status === 401) {
                //直接转到登录页
                store.commit("logoutUserInfo");

                if (error.response.config.url?.includes("rpamobile")) {
                    router.push({ name: "mobile-single-login" });
                } else {
                    router.push({ name: "single-login" });
                }
            }
            return Promise.reject(error);
        } else {
            // 断网
            return Promise.reject(error);
        }
    }
);

export default _axios;
